import request from '@/utils/request'
import store from '@/store'

// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

// 获取奖项列表
export function getPrizeList(params) {
  return request({
    url: '/prize/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 奖项管理：平均分配当前活动全部奖项概率（包含未展示的奖项）。
export function distributePrizeProbability(subAccountId) {
  return request({
    url: '/prize/distributeProbability',
    method: 'post',
    data: { adminId: subAccountId || getAdminId() }
  })
}

// 按数据库中已保存的概率比例，将当前活动全部奖项概率调整至100%。
export function normalizePrizeProbability(subAccountId) {
  return request({
    url: '/prize/normalizeProbability',
    method: 'post',
    data: { adminId: subAccountId || getAdminId() }
  })
}

// 一键复制奖品列表：从源活动复制所有奖项到目标活动
export function copyPrizesFromActivity(sourceCode, targetAdminId) {
  return request({
    url: '/prize/copyFromActivity',
    method: 'post',
    data: {
      sourceCode,
      targetAdminId: targetAdminId || getAdminId()
    }
  })
}

// 新增奖项
export function addPrize(data) {
  return request({
    url: '/prize/add',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 抽号码活动：添加号码范围（startNumber ~ endNumber）
export function addNumberRange(data) {
  return request({
    url: '/lottery/prize/add',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// 编辑奖项
export function updatePrize(id, data) {
  return request({
    url: '/prize/edit',
    method: 'put',
    data: {
      ...data,
      id,
      adminId: getAdminId()
    }
  })
}

// 删除奖项
export function deletePrize(id) {
  return request({
    url: `/prize/delete/${id}`,
    method: 'delete',
    params: {
      adminId: getAdminId()
    }
  })
}

// ========== 临时需求 - SWJG8947UDNB 特殊内定：选中奖项概率置100、其余置0 ==========
export function setFixedPrize(prizeId) {
  return request({
    url: '/prize/setFixed',
    method: 'post',
    data: {
      adminId: getAdminId(),
      prizeId
    }
  })
}
// ========== 临时需求结束 ==========

// 通用内定：选中奖项概率置100、其余置0（不限活动类型，后台“单机版模式”使用）
export function fixPrize(prizeId) {
  return request({
    url: '/prize/fixPrize',
    method: 'post',
    data: {
      adminId: getAdminId(),
      prizeId
    }
  })
}

// ========== 临时需求 - 特殊内定栏目：平均概率 + 同一奖品不可重复中 ==========
// 平均分配所有奖项概率
export function averageProbability() {
  return request({
    url: '/prize/averageProbability',
    method: 'post',
    data: {
      adminId: getAdminId()
    }
  })
}

// 查询“同一奖品不可重复中”设置（1-同一奖品不可重复中 0-可重复中(默认)，与 allowRepeatLottery 完全独立）
export function getRepeatSamePrize() {
  return request({
    url: '/prize/repeatSamePrize',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

// 保存“同一奖品不可重复中”设置（1-同一奖品不可重复中 0-可重复中(默认)）
export function updateRepeatSamePrize(noRepeatSamePrize) {
  return request({
    url: '/prize/repeatSamePrize',
    method: 'post',
    data: {
      adminId: getAdminId(),
      noRepeatSamePrize
    }
  })
}
// ========== 临时需求结束 ==========
